import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Logging, AskingQuestion, CustomLoading } from './LoadingComponent';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Input, Button, 
         Card, CardBody, CardSubtitle, CardText, 
         FormGroup, Label, Alert } from 'reactstrap';
import { RenderTable } from './TableComponent';
import { CSVLink } from "react-csv";
import { getLlmResponse, fetchJsonFile } from '../redux/ActionCreators';
import { months_map } from '../shared/data';

// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    client_params: state.client_params,
    question_market_view: state.question_market_view,
    chat_market_view:state.chat_market_view,
    llm_market_view_topic:state.llm_market_view_topic,
    date_market_view:state.date_market_view,
    report_analysis:state.report_analysis,
  };
};

class ChatStrategy extends Component {
    constructor(props){
      super(props);
      this.state = {
        loading_question:false,
        loading_report:false,
        loading_review:false,
        ref_date:'',
        msg_ind:false,
        msg:null,
        msg_review:null,
        nodes:null,
        report_msg:null
      };
      this.sendQuestion = this.sendQuestion.bind(this);
      this.resetHistory = this.resetHistory.bind(this);
      this.handleTopicChange = this.handleTopicChange.bind(this);
      this.onDismiss = this.onDismiss.bind(this);
      this.loadReport = this.loadReport.bind(this);
    }

    async sendQuestion(){
      this.setState({loading_question:true});
      try {
        if(this.props.question_market_view==null | this.props.question_market_view==''){
            this.setState({
              msg_ind:true,
              msg:"Escribe tu pregunta!"
            });
        } else {
          const resp = await getLlmResponse({
              question:this.props.question_market_view, 
              index_name:"documents-index",
              vector_bucket:"condor-vectors",
              metadata:{
                doc_type:"market_strategy",
                entity:this.props.llm_market_view_topic,
                date:this.props.date_market_view=='' ? null : `${this.props.date_market_view.replace("-","")}`,
                },
              chat_history:this.props.chat_market_view.slice(0,5)            
          });
          console.log(resp)
          if (resp.status=='ok'){
            this.props.changeModel('chat_market_view', [...this.props.chat_market_view, {role:"user", content:this.props.question_market_view}, {role:"assistant", content:resp.answer}]);
            this.setState({
              msg_ind:false,
              nodes:resp.nodes_loc
            });
          }else{
            this.setState({
              msg_ind:true,
              msg:resp.msg
            });
          }
          this.setState({
            loading_question:false,
            ref_date:resp.ref_date
          });
        };
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({loading_question:false});
      }
    }

    resetHistory(){
      this.props.changeModel('chat_market_view', []);
    }

    handleTopicChange(event){
      if (event.target.checked){
        this.props.changeModel('llm_market_view_topic', this.props.llm_market_view_topic.concat([event.target.id]));      
      }else{
        this.props.changeModel('llm_market_view_topic', this.props.llm_market_view_topic.filter(x=>x!==event.target.id));
      }
    }
    
    onDismiss() {
      this.setState({ msg_ind: false });
    }

    loadReport = async () => {
      this.setState({loading_report:true});
      console.log(`market_report/committee_global/${this.props.date_market_view.slice(0,4)}/${this.props.date_market_view.slice(5,7)}/report.json`);
      try {
        this.setState({loading_report:true});
        const resp_report = await fetchJsonFile({
            bucket:'condor-sura-wm', 
            key:`market_report/committee_global/${this.props.date_market_view.slice(0,4)}/${this.props.date_market_view.slice(5,7)}/report.json`
        });
        this.setState({
          loading_report:false,
          report_msg:null
        });
        this.props.changeModel('report_analysis', resp_report);
      } catch (error){
        console.error('Error getting response:', error);
        this.setState({
          loading_report:false,
          report_msg:`Reporte de mercado no se ha generado para ${months_map[this.props.date_market_view.slice(-2)]} de ${this.props.date_market_view.slice(0,4)}. Puedes ver el reporte del mes anterior.`
        });
      }
    }

    render(){
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else {
        const chat_market_view = [...this.props.chat_market_view].reverse().map((item, i)=>{
          if (item.role=="user"){
            return(
              <Card className='m-2' key={i}>
                <CardBody>
                  <CardSubtitle
                    className="mb-2 text-muted"
                    tag="h6"
                  >
                    Pregunta: {item.content}
                  </CardSubtitle>
                  <CardText tar="div">
                    {[...this.props.chat_market_view].reverse()[i-1].content.map((block, idx) => {
                    if (block.type === "text") {
                      return <p className="chat" key={idx}>{block.content}</p>;
                    }
                    if (block.type === "table") {
                      const colCount = block.columns.length;
                    
                      return (
                      <>
                        <div key={idx} style={{ overflowX: "auto", marginBottom: "1rem" }}>
                          <table
                            style={{
                              margin: "0 auto",              // ✅ center
                              borderCollapse: "collapse",
                              fontSize: "0.9rem",
                              minWidth: `${colCount * 120}px`, // ✅ dynamic width
                            }}
                          >
                            <thead>
                              <tr>
                                {block.columns.map((col, i) => (
                                  <th
                                    key={i}
                                    style={{
                                      borderBottom: "1px solid #ccc",
                                      padding: "6px 10px",
                                      textAlign: "center",
                                      fontSize: "0.9rem"
                                    }}
                                  >
                                    {col}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {block.rows.map((row, i) => (
                                <tr key={i}>
                                  {row.map((cell, j) => (
                                    <td
                                      key={j}
                                      style={{
                                        padding: "6px 10px",
                                        textAlign: typeof cell === "number" ? "right" : "center",
                                        fontSize: "0.8rem"
                                      }}
                                    >
                                      {cell}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className='row mb-4 justify-content-center'>
                          <CSVLink className='link-btn' data={[block.columns].concat(block.rows)} filename="tabla"><small>descargar tabla&darr;</small></CSVLink>
                        </div>
                      </>
                      );
                    }                
                      return "";
                    })}
                  </CardText>
                </CardBody>
              </Card>
              );
          }else{
            return null;            
          }
        });
        
        const market_summ = this.props.report_analysis?.analysis || null;
        //console.log(market_summ)
        return(
            <div className='container'>
              <div className="row mt-4 justify-content-center">
                <div className="col-12 m-3" id="preview">
                  <h5> <center>Comentario de Mercado</center></h5>
                  <a className='linkcol' href='#chat'>chat&darr;</a>
                </div>
              </div>
              <div className="row justify-content-center">
              <div className="col-2">
                <Input 
                  type="month"
                  lang="es"
                  value={this.props.date_market_view} 
                  onChange={(e)=>this.props.changeModel('date_market_view',e.target.value)}
                  placeholder="Fecha..."
                >
                </Input>
              </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className="col-12 m-3" id="load">
                  {this.state.loading_report ?
                  <CustomLoading msg="cargando reporte de mercado" icon="fa-compass" />
                  :
                  <Button className="btn-corp" onClick={this.loadReport}>
                    <small>Resumen de Mercado &darr;</small>
                  </Button>
                  }
                </div>
              </div>
              <div className="row m-2 justify-content-center">
                <div className="col-6">
                  <Alert
                    color={this.state.report_msg!==null && this.state.report_msg.includes('Error') ? 'danger':'secondary'}
                    isOpen={this.state.report_msg!=='' && this.state.report_msg!==null} 
                    toggle={()=>this.setState({report_msg:null})}
                    fade={false}
                    >
                      {this.state.report_msg}
                  </Alert>
                </div>
              </div>
              {market_summ!==null ?
              <>
                <div className="row m-3 justify-content-center">
                  <div className="col-8">
                    <h5><center>Factores Relevantes</center></h5>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-8 text-start">
                    <ul className="list-disc list-outside pl-6 m-0">
                      {Object.keys(market_summ.global_facts).map((k, i) => (
                        <li className="m-0 p-0" key={i}>
                          {market_summ.global_facts[k]}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              {Object.keys(market_summ.latin_american_facts).map((item,i)=>{
                return (
                  <>
                    <div className="row mt-4 mb-2 justify-content-center">
                      <div className="col-8">
                        <h6><center>{item}</center></h6>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="col-8 text-start">
                          <ul className="list-disc list-outside pl-6 m-0">
                            {Object.keys(market_summ.latin_american_facts[item]).map((k,i)=>{
                              return <li className="m-0 p-0" key={i}>{market_summ.latin_american_facts[item][k]}</li>
                            })}                      .
                          </ul>
                      </div>
                    </div>
                  </>
                );
              })}
                <div className="row mt-4 mb-2 justify-content-center">
                  <div className="col-8">
                    <h5><center>Conclusiones</center></h5>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-8 text-start">
                      <ul className="list-disc list-outside pl-6 m-0">
                        <li className="m-0 p-0">{market_summ.global_market_summary}</li>
                        <li className="m-0 p-0">{market_summ.latin_american_market_summary}</li>
                      </ul>
                  </div>
                </div>
                <div className="row mt-4 mb-2 justify-content-center">
                  <div className="col-8">
                    <h5><center>Recomendaciones</center></h5>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-8 text-start">
                    <ul className="list-disc list-outside pl-6 m-0">
                      {Object.keys(market_summ.investment_recommendations).map((k, i) => (
                        <li key={i} className="m-0 p-0"><b>{k.replace("_"," ")}: </b>{market_summ.investment_recommendations[k]}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="row m-4 justify-content-center">
                  <div className="col-3">
                    <RenderTable 
                      data={[{Region:'Global', 'Sentimiento':market_summ.global_sentiment_score},
                             {Region: 'Latam', 'Sentimiento':market_summ.latin_american_sentiment_score}]
                      }
                    />
                  </div>
                </div>
              </>
              : <></>
              }

              <div className="row justify-content-center">
                <div className="col-12 m-3">
                  <hr />
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className="col-12 m-3" id="chat">
                  <h5> <center>Chat de Mercado</center></h5>
                  <a className='linkcol' href='#preview'>comentario&uarr;</a>
                </div>
              </div>
              <div className="row justify-content-center align-items-center m-5">
                <div className="col-3">
                  <img src={require('../shared/minelli.jpg')} alt={"MINELLI"} width="60%"/>
                </div>
                <div className="col-3">
                  <h6>Hola soy SURI, estratega de inversiones. Estoy aquí para entregarte información útil y ayudarte a navegar por los mercados con confianza. {this.state.ref_date==='' ? '' : 'Ten en cuenta sólo tengo información hasta ' + this.state.ref_date} </h6>
                </div>
              </div>
              <div className='row justify-content-center'>
                <div className='col-3'>
                  <Alert
                    color="info" 
                    isOpen={this.state.msg_ind} 
                    toggle={this.onDismiss}
                    fade={false}
                    >
                    {this.state.msg}
                  </Alert>
                </div>
              </div>
              <div className="row m-3 justify-content-center">
                <div className="col-8">
                  <Input
                    type="text"
                    id="textInput"
                    placeholder={'Escribe tu pregunta para SURI!'}
                    value={this.props.question_market_view || ''}
                    onChange={(e)=>this.props.changeModel('question_market_view', e.target.value)}
                  />                
                </div>
              </div>
              <div className='row justify-content-center align-items-end'>
                <div className='col-2 mt-3'>
                  {this.state.loading_question ? 
                    <AskingQuestion/>
                  :
                    <Button className="btn-corp" onClick={this.sendQuestion}>
                      <small>Preguntar</small>
                    </Button>
                  }
                </div>
                <div className='col-2 mt-3'>
                  <Button className="btn-corp" onClick={this.resetHistory}>
                    <small>Eliminar historia</small>
                  </Button>
                </div>
              </div>
              <div className='row justify-content-center align-items-end'>
                {this.state.nodes!==null ?
                <div className='col-2 mt-3'>
                  <CSVLink className='link-btn' data={this.state.nodes} filename="nodes"><small>descargar detalle &darr;</small></CSVLink>
                </div>
                : null
                }
              </div>
              <div className="row mt-5 mb-5 justify-content-center">
                <div className="col">
                  <hr/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col">
                  {this.props.chat_market_view.length>0 ? <h6> Conversación </h6> : <></>}
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col' style={{maxHeight: '400px',overflowY: 'auto'}}>
                  {chat_market_view}
                </div>
              </div>
            </div>
        );
      }
    }
}

export default withRouter(connect(mapStateToProps)(ChatStrategy));
